/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator';
import { useNotificationStore } from '../stores/notificationsStore';
import { GenericNotificationMessage } from '../models/mqttPayload/GenericNotificationMessage';
import { NotificationMessageType } from '../models/NotificationMessageType';

@Component
export default class NotificationMixIn extends Vue {
  notificationStore = useNotificationStore();

  get snackBar(): boolean {
    return this.notificationStore.snackbar;
  }
  set snackBar(state: boolean) {
    this.notificationStore.setSnackbar(state);
  }

  get alertMessage(): string {
    return this.notificationStore.message;
  }

  showNotification(message: string) {
    this.notificationStore.setMessage(message);
  }
  processNotification(message: GenericNotificationMessage) {
    switch (message.Type) {
      case NotificationMessageType.MissionStart:
        this.showNotification(
          `${this.$t('notifications.Mission')} ${message.MessageValues[0]} ${this.$t('notifications.for')} ${message.MessageValues[1]} ${this.$t(
            'notifications.started'
          )}`
        );
        break;
      case NotificationMessageType.MissionPause:
        this.showNotification(
          `${this.$t('notifications.Mission')}  ${message.MessageValues[0]} ${this.$t('notifications.for')} ${message.MessageValues[1]} ${this.$t(
            'notifications.paused'
          )}`
        );
        break;
      case NotificationMessageType.MissionCompleted:
        this.showNotification(
          `${this.$t('notifications.Mission')}  ${message.MessageValues[0]} ${this.$t('notifications.for')} ${message.MessageValues[1]} ${this.$t(
            'notifications.completed'
          )}`
        );
        break;
      case NotificationMessageType.MissionCancelled:
        this.showNotification(
          `${this.$t('notifications.Mission')}  ${message.MessageValues[0]} ${this.$t('notifications.for')} ${message.MessageValues[1]} ${this.$t(
            'notifications.cancelled'
          )}`
        );
        break;
      case NotificationMessageType.NewField:
        this.showNotification(`${this.$t('notifications.Field')} ${message.MessageValues[0]} ${this.$t('notifications.created')}`);
        break;
      case NotificationMessageType.NewPath:
        this.showNotification(`${this.$t('notifications.Path')} ${message.MessageValues[0]} ${this.$t('notifications.created')}`);
        break;
      case NotificationMessageType.ModifiedField:
        this.showNotification(`${this.$t('notifications.Field')} ${message.MessageValues[0]} ${this.$t('notifications.modified')}`);
        break;
      case NotificationMessageType.ModifiedPath:
        this.showNotification(`${this.$t('notifications.Path')} ${message.MessageValues[0]} ${this.$t('notifications.modified')}`);
        break;
      default:
        break;
    }
  }
}
